import { useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import apiService from "services/api";
import geniusLogo from "assets/img/genius-coffee-logo.png";
import geniusQrCode from "assets/img/genius-coffee-qr-code.jpeg";
import { useReactToPrint } from "react-to-print";
import { FiPrinter } from "react-icons/fi";

const PriceTag = ({ price, className }) => (
    <span className={className}>
        <b>HKD</b> {parseInt(price).toFixed(2)}
    </span>
);
const ShowAddPointRecord = () => {
    const receiptRef = useRef(null);
    const handlePrint = useReactToPrint({ content: () => receiptRef.current });
    const { record_id } = useParams();
    const { data: addPointRecord, isLoading } = useQuery(
        ["addPointsRecords", record_id],
        () => apiService.getAddPointsRecord(record_id)
    );

    return !isLoading ? (
        <div className="content">
            <div className="d-flex justify-content-between mb-3">
                <Link to="/coffee/add-points/">
                    <button className="btn btn-info btn-sm">&lt; Back</button>
                </Link>

                <button className="btn btn-info btn-icon" onClick={handlePrint}>
                    <FiPrinter />
                </button>
            </div>

            <div className="d-flex justify-content-center">
                <div
                    className="card card-body bg-white print px-0 pb-0"
                    ref={receiptRef}
                    style={{ maxWidth: 320 }}
                >
                    <pre className="text-wrap small">
                        <div className="text-center">
                            <img src={geniusLogo} alt="" width="80" />
                        </div>

                        <div className="card-header text-center">
                            <div className="text-dark text-center h4 mb-1">
                                <b>Receipt</b>
                            </div>
                            <small className="text-dark d-block">
                                10 Somerset Road,
                            </small>
                            <small className="text-dark d-block">
                                Kowloon Tong
                            </small>
                        </div>

                        <div className="card-body">
                            <small>
                                <dl className="row no-gutters text-dark">
                                    <div className="col-4">Ref No.:</div>
                                    <div className="col-8">
                                        APRE-{record_id}
                                    </div>
                                    <div className="col-4">Date:</div>
                                    <div className="col-8">
                                        {new Date(
                                            addPointRecord?.createdAt
                                        ).toLocaleString()}
                                    </div>
                                    <div className="col-4">Staff:</div>
                                    <div className="col-8">
                                        {addPointRecord?.createdBy?.fullName}
                                    </div>
                                    <div className="col-4">Customer:</div>
                                    <div className="col-8">
                                        {addPointRecord?.user?.firstName +
                                            " " +
                                            addPointRecord?.user?.lastName}
                                    </div>
                                </dl>
                                <div className="mt-3">
                                    {/* <h6 className="text-dark">
                                        <b>Purchase</b>
                                    </h6> */}
                                    <ul className="text-dark pl-3">
                                        <li className="text-dark">
                                            <div className="row justify-content-between no-gutters">
                                                <span className="col-8">
                                                    {
                                                        addPointRecord.membershipPoints
                                                    }
                                                    pts
                                                </span>
                                                <PriceTag
                                                    className="col-4 text-right"
                                                    price={
                                                        addPointRecord.membershipPoints
                                                    }
                                                />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <hr
                                    className="bg-dark"
                                    style={{
                                        paddingTop: 0.7,
                                        paddingBottom: 0.7,
                                    }}
                                />
                                <div className="d-flex justify-content-between text-dark ml-2">
                                    <span>Subtotal: </span>
                                    <PriceTag
                                        price={addPointRecord.membershipPoints}
                                    />
                                </div>
                                <div className="d-flex justify-content-between text-dark ml-2">
                                    <b>Total: </b>
                                    <PriceTag
                                        price={addPointRecord.membershipPoints}
                                    />
                                </div>
                            </small>
                        </div>

                        <small className="card-footer d-flex flex-column text-dark text-center">
                            <span>Check out website at</span>
                            <span>coffee.geniusdevelopment.com</span>
                            <div className="text-center mt-3">
                                <img src={geniusQrCode} alt="" width="120" />
                            </div>
                        </small>
                    </pre>
                </div>
            </div>
        </div>
    ) : (
        <div>Loading</div>
    );
};

export default ShowAddPointRecord;
